import { MouseEvent, useCallback } from 'react';
import { connect } from 'react-redux';

import { ChecklistAnswerCodesEnum } from 'APIPackage/CatalogsModule/enums/ChecklistAnswerCodesEnum';
import { Dropdown } from 'UIPackage/MainModule/components/Dropdown';
import { DropdownItem } from 'UIPackage/MainModule/components/DropdownItem';
import { IDropdownItem } from 'UIPackage/MainModule/interfaces/IDropdownItem';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';
import { IKnmErknmFormChecklist } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormChecklist';
import { IKnmErpFormChecklist } from 'KnmErpPackage/KnmErpChecklistsModule/interfaces/IKnmErpFormChecklist';
import { IChecklistAnswerTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IChecklistAnswerTypeSelectOption';
import { getChecklistAnswerTypesSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { IKnmForm } from '../interfaces/IKnmForm';
import { IKnmFormRef } from '../interfaces/IKnmFormRef';
import { getKnmFormRef } from '../selectors/knmSelectors';

interface IKnmChecklistDropdownProps {
  disabled: boolean;
  questionAnswerTypeFieldName: string;
  itemsCheck: TableCheckItems;
  data: IKnmErknmFormChecklist | IKnmErpFormChecklist;
  checklistAnswerTypesSelectOptions: IChecklistAnswerTypeSelectOption[] | undefined;
  fieldName: string;
}

interface IKnmChecklistDropdownStoreProps {
  formRef: IKnmFormRef | undefined;
  checklistAnswerTypesSelectOptions: IChecklistAnswerTypeSelectOption[] | undefined;
}

const KnmChecklistDropdownWithoutStore = ({
  disabled,
  questionAnswerTypeFieldName,
  itemsCheck,
  data,
  checklistAnswerTypesSelectOptions,
  formRef,
  fieldName,
}: IKnmChecklistDropdownProps & IKnmChecklistDropdownStoreProps) => {
  const handleCheckSelectedButtonClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      const { format } = event.currentTarget.dataset;
      const answerTypeCode = format as ChecklistAnswerCodesEnum;

      Object.keys(itemsCheck).forEach(itemId => {
        if (itemsCheck[itemId]) {
          const questionIndex = data.questions
            ? data.questions.findIndex(question => `${question.listId}` === itemId)
            : -1;
          const checklistAnswerTypeSelectOption = checklistAnswerTypesSelectOptions?.find(
            item => item.code === answerTypeCode,
          );

          if (questionIndex >= 0 && checklistAnswerTypeSelectOption) {
            const answerTypeFieldName = `${fieldName}.questions[${questionIndex}].${questionAnswerTypeFieldName}` as keyof IKnmForm;

            formRef?.current.change(answerTypeFieldName, checklistAnswerTypeSelectOption);
          }
        }
      });
    },
    [checklistAnswerTypesSelectOptions, data.questions, fieldName, formRef, itemsCheck, questionAnswerTypeFieldName],
  );

  const dropdownItems: IDropdownItem[] = [
    {
      id: 'check-yes',
      content: (
        <DropdownItem onClick={handleCheckSelectedButtonClick} format={ChecklistAnswerCodesEnum.TYPE_I}>
          Отметить выделенные &quot;Да&quot;
        </DropdownItem>
      ),
    },
    {
      id: 'check-no',
      content: (
        <DropdownItem onClick={handleCheckSelectedButtonClick} format={ChecklistAnswerCodesEnum.TYPE_II}>
          Отметить выделенные &quot;Нет&quot;
        </DropdownItem>
      ),
    },
    {
      id: 'check-other',
      content: (
        <DropdownItem onClick={handleCheckSelectedButtonClick} format={ChecklistAnswerCodesEnum.TYPE_OTHER}>
          Отметить выделенные &quot;Иное&quot;
        </DropdownItem>
      ),
    },
  ];

  return <Dropdown items={dropdownItems} disabled={disabled} />;
};

const mapStateToProps = (state: IRootState): IKnmChecklistDropdownStoreProps => ({
  formRef: getKnmFormRef(state),
  checklistAnswerTypesSelectOptions: getChecklistAnswerTypesSelectOptions(state),
});

export const KnmChecklistDropdown = connect(mapStateToProps)(KnmChecklistDropdownWithoutStore);
